module.exports = __webpack_public_path__ + "img/765938_1F1009_A59C7C_C9A382-256px.c57d9481.png";